import { memo, useCallback, useMemo } from "react";

import { useCopyToClipboard } from "@/lib/react-use/use-copy-to-clipboard";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { Button } from "@/components/ui/button/button";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { FormIslandSection } from "./island-section";

type Props = {
	domainName: string;
	subDomainName: string;
	errorMessage?: string;

	onChangeDomain: (subDomainName: string) => void;
};

const HTTPS = "https://";
const BaseDomain = import.meta.env.VITE_BASE_DOMAIN ?? "";

export const UrlSettingForm = memo(({ domainName, subDomainName, errorMessage, onChangeDomain }: Props) => {
	const handleChangeDomain = useCallback(
		(value: string) => {
			onChangeDomain(value);
		},
		[onChangeDomain],
	);

	const { copy } = useCopyToClipboard();
	const canCopy = useMemo(() => !!domainName, [domainName]);
	const handleClickCopy = useCallback(() => {
		if (!canCopy) return;

		copy(`${HTTPS}${domainName}`);

		notifyUserEventInfo({
			title: "URLをコピーしました",
		});
	}, [canCopy, copy, domainName]);

	return (
		<FormIslandSection title="URL設定" showChildrenDivider={false}>
			<div className="w-full text-right">
				<Button type="button" variant="outline" onClick={handleClickCopy} disabled={!canCopy}>
					コピー
				</Button>
			</div>

			<div className="w-full space-y-2">
				<div className="flex items-center justify-start gap-x-2">
					<div className="inline text-sm xl:text-base">https://</div>

					<InputTextField
						value={subDomainName}
						handleChange={handleChangeDomain}
						errorMessage={errorMessage}
					/>

					<div className="inline text-sm xl:text-base">{BaseDomain}</div>
				</div>
			</div>
		</FormIslandSection>
	);
});
